import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import SaveIcon from "@material-ui/icons/Save";
import { makeStyles } from "@material-ui/core";
import TemplateCard from "../TemplateCard/TemplateCard";
import iconFolderGrey from "../../../../Assets/templateV2/folder_grey.svg";
import useDocFormsStore from '../../store/docFormsStore';

const useStyles = makeStyles((theme) => ({
	container: {
		backgroundColor: "#fff",
		marginTop: "16px",
		padding: "14px 16px",
		height: "100%",	
		flex: 1,
		display: "flex",
		flexDirection: "column",
		justifyContent: "space-between",
	},
	gridContainer: {
		display: "flex",
		flexWrap: "wrap",
		gap: "16px",
		alignItems: "center",
	},
}));

const optionsMenu = [
	{
		label: "Recover",
		value: "Recover",
		icon: <SaveIcon />,
	},
];
export default function ArchiveView({
	setLoading,
	reloadTemplates,
	setReloadTemplates,
}) {
	const navigate = useNavigate();
	const notify = (msj, event) => toast[event](msj);
	const classes = useStyles();

	const archiveForms = useDocFormsStore(state => state.archiveForms);

	const [startPage] = useState(true);

	const [page, setPage] = useState(1);
	const [mpage, setMPage] = useState(0);
	const [valueSearch, setValueSearch] = useState("");
	const [listDocuments, setListDocuments] = useState([]);
	const [pageSize, setPageSize] = useState(50);
	const [listDocumentsTotal, setListDocumentsTotal] = useState([]);


	useEffect(() => {
		if (startPage) {
			initPage(true);
		}
	}, [startPage]);

	const initPage = async () => {
		try {
			setLoading(true, "Loading...");
			// await getArchiveFiles(true);
		} catch (err) {
		} finally {
			setLoading(false);
		}
	};



	const handleRecoverTemplate = async (template) => {
		try {
			setLoading(true, "Recovering template...");
			const body = {
				status: 0
			};
			// const response = await recoverArhiveFile(template.id, body);
			// if (response.status === 200) {
				notify("Template recovered", "success");
				// await getArchiveFiles(false);
				toast.success("Template recovered successfully")
			// }
		} catch (err) {
			toast.error("Error recovering template")
		} finally {
			setLoading(false);
		}
	}

	const handleClickMenuItem = (menu, template) => {
		console.log("menu", menu);
		console.log("template", template);
		switch (menu) {
			case "Recover":
				handleRecoverTemplate(template);
				break;
			default:
				break;
		}
	};


	return (
		<div className={classes.container}>
			<div className={classes.gridContainer}>
					{archiveForms.map((template) => (
						<TemplateCard
							docIcon={iconFolderGrey}
							optionsMenu={optionsMenu}
							template={template}
							onClickMenu={handleClickMenuItem}
						/>
				))}
			</div>

			{/* <Pagination
						currentPage={currentPage}
						itemsPerPage={templatesPerPage}
						totalItems={templates.length}
						onPageChange={handlePageChange}
					/> */}
		</div>
	);
}
